import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
var useAnimationEnd = function useAnimationEnd(onEnd) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExiting = _useState4[0],
    setIsExiting = _useState4[1];
  var elementRef = useRef(null);
  var handleStartExit = function handleStartExit() {
    setIsExiting(true);
  };
  useEffect(function () {
    var handleAnimationEnd = function handleAnimationEnd() {
      if (isExiting) {
        setIsVisible(false);
        setIsExiting(false);
        onEnd();
      }
    };
    var element = elementRef.current;
    if (element) {
      element.addEventListener('animationend', handleAnimationEnd);
    }
    return function () {
      if (element) {
        element.removeEventListener('animationend', handleAnimationEnd);
      }
    };
  }, [isExiting, onEnd]);
  return {
    isVisible: isVisible,
    isExiting: isExiting,
    handleStartExit: handleStartExit,
    elementRef: elementRef
  };
};
export { useAnimationEnd };